
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/boost-employee-onboarding-scheduled-teams-messages",
      function () {
        return require("private-next-pages/article/boost-employee-onboarding-scheduled-teams-messages.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/article/boost-employee-onboarding-scheduled-teams-messages"])
      });
    }
  